"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminCheckGoogleMaps = void 0;
const react_1 = __importDefault(require("react"));
const GoogleMapsAutoroute_1 = __importDefault(require("../../../services/GoogleMapsAutoroute/GoogleMapsAutoroute"));
const AdminCheckGoogleMaps = () => {
    return (react_1.default.createElement("main", { style: { maxWidth: 1200, margin: "0 auto", padding: 16 } },
        react_1.default.createElement(GoogleMapsAutoroute_1.default, null)));
};
exports.AdminCheckGoogleMaps = AdminCheckGoogleMaps;
